import { useContext, useEffect, useState } from "react";
import type { EHR } from "vim-os-js-browser/api/vim-os-sdk-api";
import { VimOSContext } from "./vimOSContext";


export const useVimOSPatient = () => {
    const vimOS = useContext(VimOSContext);
    const [patient, setPatient] = useState<EHR.Patient | undefined>(undefined);
    useEffect(() => {
      vimOS?.ehr.subscribe('patient', setPatient);
      return () => {
        vimOS?.ehr.unsubscribe('patient', setPatient);
      }
    }, [vimOS]);
    return patient;
  }